var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, FieldValidation, TextInput, } from '#design-system';
import { useField, useFieldDependency } from '#form-builder';
import { C } from '#integrations';
import styles from './TextInputField.module.css';
const defaultValidationRules = [];
export const TextInputField = ({ 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoComplete = 'off', autoFocus, className, clientErrorMessage, copyProps, 'data-testid': testId, description, disabled, id, initialValue, label, labelTooltip, onKeyDown, placeholder, readOnly, required, rules = defaultValidationRules, shouldDisablePasswordManagers = true, tooltipPosition, ...props }) => {
    _react_refresh_temp_2();
    const builtInitialValue = useMemo(() => {
        if (typeof initialValue === 'function') {
            return initialValue({}) || '';
        }
        else {
            return initialValue || '';
        }
    }, [initialValue]);
    const { 
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- dependencyValue is any on purpose
    dependencyValue, errors, fieldRef, isFocused, isTouched, onBlurHandler, onChangeHandler, onFocusHandler, value, } = useField({
        autoFocus,
        ...props,
        disabled,
        initialValue: builtInitialValue,
    });
    const dependantData = useFieldDependency({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- dependencyValue is any on purpose
        dependencyValue,
        disabled,
        label,
        required,
    });
    const hasErrors = Boolean(errors.length) && isTouched;
    const fieldValidationId = `field-validation-${id}`;
    return (_jsxs(Box, { className: C(styles.Container, className), gap: "xs", isFullWidth: true, orientation: "vertical", children: [_jsx(TextInput, { "aria-describedby": fieldValidationId, ...(hasErrors && { 'aria-errormessage': fieldValidationId }), ...(hasErrors && { 'aria-invalid': true }), "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, autoComplete: autoComplete, autoFocus: autoFocus, copyProps: copyProps, "data-testid": testId, description: description, disabled: dependantData.disabled, hasErrors: hasErrors, id: id, label: dependantData.label, labelTooltip: labelTooltip, onBlur: onBlurHandler, onChange: (event) => {
                    onChangeHandler(event.target.value);
                }, onFocus: onFocusHandler, onKeyDown: onKeyDown, placeholder: placeholder, readOnly: readOnly, ref: fieldRef, required: dependantData.required, shouldDisablePasswordManagers: shouldDisablePasswordManagers, tooltipPosition: tooltipPosition, value: value }), _jsx(FieldValidation, { clientErrorMessage: clientErrorMessage, "data-testid": testId, errors: errors, id: fieldValidationId, isActive: isTouched, isFocused: isFocused, rules: rules })] }));
};
_react_refresh_temp_1 = TextInputField;
$RefreshReg$(_react_refresh_temp_1, "TextInputField");
_react_refresh_temp_2(TextInputField, "7LnEM1IR9rsqY4ujvpRYmMDdRBE=", false, () => [useField, useFieldDependency]);
